import { TranslateService } from '@ngx-translate/core';
import { async } from '@angular/core/testing';
import { ValidateCguComponent } from './../../dialog/validate-cgu/validate-cgu.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PageConfigService } from 'src/app/page-config.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ServiceInfo } from 'src/app/models/display/serviceInfo';
import { UserApi } from 'src/app/models/api_models/user';
import { UserApiService } from 'src/app/user-api.service';
import {  CookieService} from 'ngx-cookie-service';
import { AutorizationService } from 'src/app/api/autorization.service';



@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.scss']
})
export class AuthHeaderComponent implements OnInit {
  _servicesList: ServiceInfo[] = [];
  _currentUser: UserApi;
  isUserLoad: boolean = false;
  constructor( public translate: TranslateService, private cookieService :CookieService, private PageConfigService: PageConfigService, private userApiService: UserApiService, private authService: AutorizationService, private router: Router, public dialog: MatDialog) {
    this.PageConfigService.config.subscribe((x) => {
      this.img = x.header_img_src; 
      this.old_link = x.old_link; 
      this.header_url = x.header_url;
      this.UrlCGU = x.cgu
    })

    // translate
    translate.addLangs(['fr', 'en', 'es', 'ca']);
    translate.setDefaultLang('fr');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/fr|en|es|ca/) ? browserLang : 'fr');

  }

  isMobile : boolean

  locales = [
    { label: '🇫🇷', value: 'fr' },
    { label: '🇺🇸', value: 'en' },
    { label: '🇪🇸', value: 'es' },
    { label: 'ca', value: 'ca' },
  ];



  

  img: string;
  old_link: string;
  header_url: string;
  UrlCGU: string;

  @Output() menuEmit = new EventEmitter<boolean>();

  public isMobileDivice;
  setDevice() {
    if (this.innerWidth <= 768) {
      this.isMobileDivice = false;
      return;
    }
    this.isMobileDivice = true;
  }

  public MenuAction() {
    this.menuEmit.emit(true);
  }

  public logout() {
    this.authService.logout();
  }
  public innerWidth: any;


  ngOnInit() {


    if( navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i))
      {
        this.isMobile = true
      }else{
        this.isMobile = false
      }




    this.innerWidth = window.innerWidth;
    this.setDevice();

    this.userApiService.getCurrentUserData().subscribe(
      response => {
        // console.warn(response);
        if (response.cgu_ok === false) { this.cguNotOki() }

        if (response != undefined) {
          this._currentUser = response;
          // console.log(this._currentUser);
          this.isUserLoad = true;
          this._servicesList = this._currentUser.getUserServices();
          // console.log(this._servicesList);
        }
      },
      error => {
        // console.log(error);        
      }
    );
  }


  refresh() {

    this.router.navigate(['/']).then(ok => {
      window.location.reload();
    });

  }

  //cgu is not valide
  cguNotOki() {
    this.userApiService.getUserDetail().subscribe(res => {
      if (res.contract.cgus === null)
       { 
          this.userApiService.getCGU(this.UrlCGU).subscribe((res)=>{
            this.openDialog(res.data.cgus) })
      }
      else {
        this.openDialog(res.cgus)
      }
    })
  }


  // open dialog 
  openDialog(element): void {
    this.dialog.open(ValidateCguComponent, {
      data: element,
      disableClose: true
    });
  }

  isLogin(){
   if( localStorage.getItem('token_clem_mobi')) 
   { return true}
   else{
    return false
   }
  }




}
